export const organizationColumns = ({
  selectedIds,
  handleSelectAll,
  handleSelect,
  totalRows,
}) => [
  {
    id: "select",
    label: (
      <input
        type="checkbox"
        checked={
          totalRows > 0 &&
          selectedIds.length === totalRows
        }
        onChange={handleSelectAll}
      />
    ),
    render: (org) => (
      <input
        type="checkbox"
        checked={selectedIds.includes(org.id)}
        onChange={() => handleSelect(org.id)}
        onClick={(e) => e.stopPropagation()}
      />
    ),
  },
 
  {
    id: "name",
    label: "Organization",
 
    render: (o) => (
      <div className="org-cell">
        <div className="org-name">{o.name}</div>
        <div className="org-country">{o.country || "-"}</div>
      </div>
    ),
 
    exportValue: (o) => o.name || "",
  },
 
  {
    id: "contacts_count",
    label: "Contact",
 
    render: (o) => o.contacts_count || "-",
 
    exportValue: (o) => o.contacts_count || 0,
  },
 
  {
    id: "state",
    label: "State",
 
    render: (o) => o.state || "-",
 
    exportValue: (o) => o.state || "",
  },
 
  {
    id: "active_leads",
    label: "Active Leads",
 
    render: (o) => o.active_leads || "-",
 
    exportValue: (o) => o.active_leads || 0,
  },
 
  {
    id: "active_deals",
    label: "Active Deals",
 
    render: (o) => o.active_deals || "-",
 
    exportValue: (o) => o.active_deals || 0,
  },
 
  {
    id: "status",
    label: "Status",
 
    render: (o) => (
      <span
        className={`status-badge ${
          o.status?.toLowerCase() === "active"
            ? "status-active"
            : "status-inactive"
        }`}
      >
        {o.status}
      </span>
    ),
 
    exportValue: (o) => o.status || "",
  },
 
  {
    id: "created_at",
    label: "Created Date",
 
    render: (o) =>
      o.created_at
        ? new Date(o.created_at).toLocaleDateString()
        : "-",
 
    exportValue: (o) => o.created_at,
  },

];
 
